<template>
  <el-popover
    ref="popover"
    popper-class="user-scope-selector"
    v-model="visible"
    placement="bottom-start"
    :width="width"
    trigger="click"
    @show="onShow"
    :disabled="disabled"
  >
    <!--控件-->
    <div
      :class="['user-scope-selector-container', 'container', 'pointer', disabled ? 'disabled' : '']"
      slot="reference"
    >
      <div ref="valueWrapper" v-ps class="value-wrapper">
        <div
          v-for="(item, idx) in valueForShow"
          :key="item.value"
          class="value"
          :style="
            !item.label && item.type == 'department'
              ? 'background: #FFE6E6;color: #FD5959;border-radius:4px; padding: 4px 2px 4px 4px'
              : item.type === 'user'
              ? 'border-radius:15px; padding: 2px 4px;'
              : 'border-radius:4px; padding: 4px 2px 4px 4px;'
          "
        >
          <div class="center" v-if="['user', 'role', 'var'].includes(item.type)">
            <staff-avatar size="small" :user="item"></staff-avatar>
            <span style="margin-left: 4px;max-width: 60px" v-tip>{{ item.label }}</span>
          </div>
          <span v-else>
            <svg-icon
              v-if="item.label && item.type != 'peojectRole'"
              :icon-class="'field_' + item.type"
            ></svg-icon>
            {{ item.label ? item.label : item.value }}
          </span>
          <i
            v-if="!disabled"
            class="el-icon-close"
            @click="removeItem(idx)"
            style="margin-left: 2px;"
          ></i>
        </div>
        <div v-if="!disabled" class="tip">
          <i class="el-icon-plus"></i>
          {{ tip || "选择范围" }}
        </div>
      </div>
      <i
        v-if="!disabled && clearable && filteredValue && filteredValue.length"
        class="el-icon-circle-close remove-all"
        @click="removeAll"
      ></i>
    </div>

    <el-input
      ref="searchInput"
      placeholder="搜索"
      prefix-icon="el-icon-search"
      v-model="searchText"
      style="z-index: 1;padding: 6px;box-sizing: border-box;"
      @keyup.native.enter="selectFirst"
    ></el-input>

    <template v-if="searchText">
      <!--搜索内容列表-->
      <search-list
        ref="searchList"
        :search-text="_.trim(searchText)"
        :selected="value"
        :grouped-options="groupedOptions"
        @change="itemChange"
      ></search-list>
    </template>
    <template v-else>
      <!--Tab页-->
      <div v-if="tabs.length > 1" class="tab-wrapper">
        <div
          v-for="tab in tabs"
          :key="tab.value"
          @click="curTab = tab.value"
          :class="['tab-option', 'pointer', curTab === tab.value ? 'selected' : '']"
        >
          {{ tab.label }}
        </div>
      </div>
      <!--Tab内容-->
      <div class="tab-content">
        <select-user
          v-if="curTab === 'user'"
          :selected="itemSelected('user')"
          :users="users"
          :root-department="rootDepartment"
          :department-map="departmentMap"
          @change="itemChange($event, 'user')"
        ></select-user>
        <select-department
          v-else-if="curTab === 'department'"
          :selected="itemSelected('department')"
          :root-department="rootDepartment"
          :department-map="departmentMap"
          @change="itemChange($event, 'department')"
          :show-raw-root-department-name="showRawRootDepartmentName"
        ></select-department>
        <select-common
          v-else
          :selected="itemSelected(curTab)"
          :options="additionalTabMap[curTab].options"
          @change="itemChange($event, curTab)"
        ></select-common>
      </div>
    </template>
    <div class="bottom">
      <div>已选 {{ selectedCount }}</div>
      <el-checkbox
        v-if="curTab === 'department' && from !== 'edit'"
        v-model="includeSubDepartment"
        @input="changeEvent"
      >
        包含下级部门
      </el-checkbox>
    </div>
  </el-popover>
</template>

<script>
import SelectUser from "./SelectUser"
import SelectDepartment from "./SelectDepartment"
import SelectCommon from "./SelectCommon"
import SearchList from "./SearchList"
import { transTreeToArr } from "@/utils/user"
import emitter from "@/mixins/emitter"
import StaffAvatar from "@/components/StaffAvatar"

export default {
  name: "UserScopeSelector",
  components: {
    StaffAvatar,
    SelectUser,
    SelectDepartment,
    SelectCommon,
    SearchList
  },
  mixins: [emitter],
  props: {
    tip: String,
    value: {
      // type: Array,
      required: true
      // default: () => [
      //   {type: "user", value: ''} // type: user,department,role
      // ]
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    showUserTab: {
      type: Boolean,
      default: true
    },
    showDepartmentTab: {
      type: Boolean,
      default: true
    },
    // 数据源
    users: {
      // 所有可选人员
      type: Array,
      default: () => []
    },
    rootDepartment: {
      // 根部门
      type: Object,
      default: () => ({})
    },
    showRawRootDepartmentName: {
      type: Boolean,
      default: false
    },
    additionalTabs: {
      type: Array
      // default: () => [
      //   {
      //     label: "角色",
      //     value: "role",
      //     options: [{ id: "1", name: "测试" }]
      //   }
      // ]
    },
    from: {
      type: String,
      default: "edit"
    },
    includeSub: Boolean
  },
  data() {
    return {
      searchText: "",
      visible: false,
      width: 300,
      // 当前列表
      selected: [],
      // 当前tab
      curTab: "user",
      includeSubDepartment: false
    }
  },
  watch: {
    includeSub: {
      handler(newVal) {
        this.includeSubDepartment = this.includeSub
      },
      immediate: true
    }
  },
  computed: {
    filteredValue() {
      return (this.value || []).filter(v => {
        switch (v.type) {
          case "user":
            return this.userMap[v.value]
          case "department":
            return this.departmentMap[v.value] ?? v
          default:
            return this.additionalTabMap[v.type]?.options?.find(t => t.id === v.value)
        }
      })
    },
    valueForShow() {
      return (this.filteredValue || []).map(v => {
        switch (v.type) {
          case "user":
            v.label = this.userMap[v.value]?.name
            v.avatar = this.userMap[v.value]?.avatar
            break
          case "department":
            v.label = this.departmentMap[v.value]?.name
            break
          default:
            v.label = this.additionalTabMap[v.type]?.options?.find(t => t.id === v.value)?.name
        }
        return v
      })
    },
    tabs() {
      let res = []
      if (this.showUserTab) {
        res.push({ value: "user", label: "人员" })
      }
      if (this.showDepartmentTab) {
        res.push({ value: "department", label: "部门" })
      }
      return res.concat((this.additionalTabs || []).map(({ label, value }) => ({ label, value })))
    },
    userMap() {
      return this._.keyBy(this.users, "id")
    },
    departmentMap() {
      let map = this._.keyBy(this._.cloneDeep(this.departments), "id")
      if (!this.showRawRootDepartmentName) {
        map[this.rootDepartment.id] && (map[this.rootDepartment.id].name = "全公司")
      }
      return map
    },
    departments() {
      let departmentTree = Object.keys(this.rootDepartment).length ? [this.rootDepartment] : []
      return transTreeToArr(departmentTree)
    },
    additionalTabMap() {
      return this._.keyBy(this.additionalTabs || [], "value")
    },
    groupedOptions() {
      let res = []
      if (this.showUserTab) {
        res.push({ value: "user", label: "人员", options: this.users })
      }
      if (this.showDepartmentTab) {
        res.push({ value: "department", label: "部门", options: this.departments })
      }
      return res.concat(this.additionalTabs || [])
    },
    selectedCount() {
      return this.filteredValue?.length || 0
    }
  },
  mounted() {
    this.curTab = this.tabs?.[0]?.value
  },
  methods: {
    onShow() {
      this.$nextTick(() => {
        this.searchText = ""
        this.$refs.searchInput?.focus()
      })
    },
    itemSelected(itemType) {
      return (this.filteredValue || []).filter(item => item.type === itemType).map(u => u.value)
    },
    removeItem(idx) {
      ;(this.filteredValue || []).splice(idx, 1)
      this.$emit("input", this.filteredValue)
    },
    removeAll() {
      this.$emit("input", [])
    },
    itemChange({ isAdd, ids }, type) {
      if (isAdd) {
        // 去重
        ids = ids.filter(u => !this.itemSelected(type).find(suid => suid === u))
        if (ids.length == 0) return
        if (!this.multiple) {
          this.$emit("input", [{ type, value: ids[0] }])
          this.visible = false
        } else {
          this.$emit("input", this.filteredValue.concat(ids.map(u => ({ type, value: u }))))
        }
      } else {
        this.$emit(
          "input",
          this.filteredValue.filter(su => {
            if (su.type !== type) return true
            return !ids.find(u => u === su.value)
          })
        )
      }
    },
    selectFirst() {
      this.searchText = this._.trim(this.searchText)
      if (!this.searchText) return
      this.$nextTick(() => {
        this.$refs.searchList.selectFirst()
        this.searchText = ""
      })
    },
    focus() {
      this.$refs.popover.doShow()
    },
    changeEvent(val) {
      this.dispatch("field-search", "department-status-change", val)
      this.dispatch("search-item", "department-status-change", val)
      this.dispatch("selectDisplay", "department-status-change", val)
      this.dispatch("condition-item", "department-status-change", val)
      this.dispatch("selectControl", "department-status-change", val)
    }
  }
}
</script>

<style>
.user-scope-selector {
  padding: 0;
}
</style>
<style lang="scss" scoped>
/*popover*/
.user-scope-selector {
  .tab-wrapper {
    display: flex;
    background: #f5f7fa;
    margin-bottom: 5px;
    height: 32px;
    .tab-option {
      &.selected {
        background: white;
      }
      text-align: center;
      line-height: 32px;
      flex: 1;
    }
  }
  .user-option-wrapper {
    .switch {
      height: 36px;
      background: #f5f7fa;
      padding: 0 10px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      .el-icon-arrow-right {
        margin-left: auto;
      }
    }
    .body-wrapper {
      padding: 6px 6px 6px 12px;
      .breadcrumb {
        display: flex;
        overflow: hidden;
        .breadcrumb-item {
          display: flex;
          flex: 0 0 auto;
          .text {
            color: #407fff;
            cursor: pointer;
            &:hover {
              text-decoration: underline;
            }
          }
          &:last-of-type {
            .text {
              color: unset;
              cursor: unset;
              &:hover {
                text-decoration: unset;
              }
            }
          }
        }
      }
    }
  }
  .role-option-wrapper {
    padding: 6px 6px 6px 12px;
  }
  .bottom {
    padding: 0 15px;
    height: 36px;
    display: flex;
    align-items: center;
    background: #f5f7fa;
    justify-content: space-between;
  }
}
/*输入框显示*/
.container {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: white;
  display: flex;
  align-items: center;
  &.disabled {
    background-color: #f5f7fa;
    border-color: #e4e7ed;
    color: #c0c4cc;
    cursor: not-allowed;
    .value {
      background-color: #ebedf2 !important;
      cursor: not-allowed !important;
    }
  }
  .value-wrapper {
    width: 100%;
    outline: none;
    display: flex;
    min-height: 32px;
    max-height: 114px; /*4行*/
    align-items: center;
    box-sizing: border-box;
    padding: 0 12px;
    flex-wrap: wrap;
    position: relative;
    .value {
      display: flex;
      align-items: center;
      flex: 0 0 auto;
      line-height: 16px;
      font-size: 14px;
      margin: 2px;
      background-color: #eaecf0;
      cursor: pointer;
      color: #303133;
      .el-icon-close {
        color: gray;
        font-size: 12px;
        &:hover {
          color: #212b36;
        }
      }
      .center {
        display: flex;
        align-items: center;
        .el-avatar {
          flex-shrink: 0;
          width: 20px;
          height: 20px;
          line-height: 20px;
          font-size: 10px;
        }
      }
    }
    .tip {
      flex: 0 0 auto;
      font-size: 14px;
      color: #1989fa;
      line-height: 20px;
      &.disabled {
        color: grey;
      }
    }
    .el-icon-caret-bottom {
      position: absolute;
      right: 2px;
    }
  }
  &:hover {
    .remove-all {
      visibility: visible;
    }
  }
  .remove-all {
    visibility: hidden;
    color: #606266;
    margin-right: 2px;
  }
}
</style>
